export default theme => ({
  fullWidth: {
    width: "100%",
  },
  mutedOnStartLabelContainer: {
    display: "flex",
    alignItems: "center",
  },
  mutedOnStartIconContainer: {
    marginLeft: "6px",
    display: "flex",
    alignItems: "center",
  },
  mutedOnStartIcon: {
    width: "18px",
  },
  mutedOnStartTooltipText: {
    fontSize: "0.95rem",
    lineHeight: 1.4,
  },
  localRecContainer: {
    display: "flex",
    alignItems: "center",
    width: "fit-content",
  },
  localRecIconContainer: {
    right: "5px",
    top: "6px",
    position: "relative",
  },
  localRecIcon: {
    width: "23px",
  },
  form__serverError: {
    color: theme.palette.userSecondary.main,
    margin: 20,
  },
});
